import { useMemo } from 'react';
import { useInitParams } from '@onramp/v2/client/contexts/initParams/InitParamsContext';
import { parseDestinationWalletsAppParam } from '@onramp/v2/client/views/onramp/card-details/utils/destinationWalletsUtils';

export const useDestinationWallets = () => {
  const { destinationWallets } = useInitParams().initParams;

  return useMemo(() => parseDestinationWalletsAppParam(destinationWallets), [destinationWallets]);
};
